import { DeliveryStatus, OrderStatus } from "@/types";

export enum TableOwnership {
    OTRAS = 'otras',
    ASIGNADAS = 'asignadas',
}

export const ORDER_STATUS_TIMESTAMP_MAP: Record<string, string> = {
    [OrderStatus.REVIEWING]: "orderedAt",
    [OrderStatus.PENDING_PAYMENT]: "approvedAt",
    [OrderStatus.PREPARING]: "approvedAt",
    [OrderStatus.REJECTED]: "rejectedAt",
    [OrderStatus.SENDING]: "sendingAt",
    [OrderStatus.COMPLETED]: "completedAt",
    [OrderStatus.ARCHIVED]: "archivedAt",
    [OrderStatus.WAITING]: "waitingAt",
};


export const DELIVERY_STATUS_TIMESTAMP_MAP: Record<string, string> = {
    [DeliveryStatus.REQUESTED]: "requestedAt",
    [DeliveryStatus.DELIVERED]: "deliveredAt",
    [DeliveryStatus.APPROVED]: "approvedAt",
    [DeliveryStatus.DECLINED]: "declinedAt",
};
